import {Task} from "./../../models/Task";
import {WrapperFactory} from "../WrapperFactory";

let tasksApi = {
    async getUserTasks(userId, token, page=null, companyId){
        return this.getTasks('user', userId, page, token, companyId)
    },
    async getArchitectTasks(architectId, token, page=null, companyId){
        return this.getTasks('architect', architectId, page, token, companyId)
    },
    async getDealTasks(dealId, token, page=null, companyId){
        return this.getTasks('deal', dealId, page, token, companyId)
    },
    async getTasks(type, id, page=null, token, companyId){
        let response = await window.axios.get('/api/tasks/'+type+'/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
                page: page
            }
        });
        let wrapper = WrapperFactory.fromResponse(response.data)
        wrapper.transform(e=>new Task(e));
        return wrapper
    },
    async show(id, token, companyId){
        let response = await window.axios.get('/api/tasks/'+id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Task(response.data);
    },
    async createTask(task, token, companyId){
        let response = await window.axios.post('/api/tasks', task, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Task(response.data);
    },
    async editTask(task, token, companyId){
        let response = await window.axios.put('/api/tasks/'+task.id, task, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Task(response.data);
    },
    async deleteTask(task, token, companyId){
        let response = await window.axios.delete('/api/tasks/'+task.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
}

export default tasksApi